var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ftStage === 1)?_c('div',[_c('CreditEnquiryForm')],1):_vm._e(),(_vm.ftStage === 2)?_c('div',[_c('CdFinalForm')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }